import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import { useDialog, useRequestState } from '@app/hooks';
import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { IClient } from '../types';
import { DeleteDialog } from '@app/components/dialog';
import { AddClient } from './add-client';
import { selectUpdateClientStatusState } from '../selector';
import { updateClientStatus } from '../slice';

interface Props {
  row: IClient;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const editDialog = useDialog();
  const activeInactiveDialog = useDialog();

  const actions = [
    { label: Strings.rowActions.edit, callback: editDialog.show },
    {
      label: Strings.common.activeInactiveTitle(row.status),
      callback: activeInactiveDialog.show,
    },
  ];
  const dispatch = useDispatch();
  const { loading: updateClients } = useRequestState({
    stateSelector: selectUpdateClientStatusState,
    onSuccess: activeInactiveDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });

  const updateClientStatusHandle = () => {
    dispatch(
      updateClientStatus({
        row,
      })
    );
  };

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.activeInactiveTitle(row.status)}  ${Strings.clients.client}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.activeInactiveCaption(row.status, Strings.clients.client)}
        loading={updateClients}
        visible={activeInactiveDialog.visible}
        onClickDelete={updateClientStatusHandle}
        onClose={activeInactiveDialog.hide}
      />
      {editDialog.visible && <AddClient open onClose={editDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
